var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarbados(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6956 1.98453C26.0662 0.713125 23.1164 0 20 0C16.8835 0 13.9337 0.713125 11.3043 1.98453L9.56519 20L11.3043 38.0155C13.9337 39.2869 16.8835 40 20 40C23.1164 40 26.0662 39.2869 28.6956 38.0155L30.4347 20L28.6956 1.98453Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3043 1.98523C4.61441 5.22007 -0.00012207 12.0708 -0.00012207 20C-0.00012207 27.9292 4.61441 34.7799 11.3043 38.0148V1.98523Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6954 1.98523V38.0148C35.3853 34.7799 39.9998 27.9291 39.9998 20C39.9998 12.0709 35.3853 5.22007 28.6954 1.98523Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0869 12.1739L27.2535 12.7572L26.0869 12.1739L24.9202 11.5906C24.8499 11.7313 23.3265 14.8308 23.0777 19.5652H21.3043V12.1739L19.9999 10.4348L18.6956 12.1739V19.5652H16.9222C16.6733 14.8308 15.15 11.7313 15.0796 11.5906L12.7463 12.7573C12.7624 12.7893 14.3478 16.0162 14.3478 20.8696V22.174H18.6956V29.5653H21.3043V22.174H25.6521V20.8695C25.6521 18.3603 26.0863 16.2912 26.4506 14.9973C26.8477 13.5864 27.251 12.7624 27.255 12.7542L26.0869 12.1739Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarbados);
export default __webpack_public_path__ + "static/media/barbados.4cb9daaabf8894e212114a0616085214.svg";
export { ForwardRef as ReactComponent };